// @ts-strict-ignore
import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';
import type { Action, WorkflowProps } from 'flow/store/engine/types';
import type { WorkflowRoutingOption } from './types';


// FIXME: BUILD-654 - centralize these helpers
export function buildWorkflowRoutingOptions(
  workflows: WorkflowProps['allWorkflows'],
  workflowsRoutedInWorkflow: Action[],
): WorkflowRoutingOption[] {
  const idsOfWorkflowsRoutedInWorkflow = workflowsRoutedInWorkflow.reduce(
    (ids, workflowRoutingAction) => ids.add(workflowRoutingAction.workflow.workflowId),
    (new Set<Action['workflow']['workflowId']>()),
  );

  return workflows
    .filter(workflow => workflow.archived === false)
    .map(workflow => {
      const workflowName = workflow.name;
      const workflowId = workflow.application_id;
      return {
        // FIXME: BUILD-1368
        disabled: idsOfWorkflowsRoutedInWorkflow.has(workflowId),
        icon: <Icon icon={IconName.Workflows} />,
        label: workflowName,
        meta: { workflowId },
        value: workflowName,
        'data-value': workflowName,
        'data-testid': workflowName,
      };
    });
}
